<template>
  <div class="ml-5">
    <div
      v-if="!Object.keys(errorsData).length"
      :class="$style.empty"
      class="grey--text text--darken-2"
    >No errors</div>
    <ul v-else>
      <li
        v-for="(messages, section) in errorsData"
        v-bind:key="section"
        class="mb-5"
      >
        <b>{{ section || 'General' }}</b>
        <ul>
          <li
            v-for="(message, index) in messages"
            v-bind:key="index + 'message'"
            class="mb-3"
          >
            <template v-if="isFinding(message)">
              <div>
                {{ message.message }}
                <code
                  v-if="message.id"
                  class="ml-1"
                >{{ message.id }}</code>
                <v-chip
                  v-if="message.ruleset"
                  x-small
                  outlined
                  class="ml-1"
                >{{ message.ruleset }}</v-chip>
              </div>
              <div
                v-if="message.location"
                class="text-body-2 grey--text text--darken-2"
              >
                {{ message.location }}
              </div>
            </template>
            <template v-else>
              {{ message }}
            </template>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  name: 'ErrorList',

  props: {
    errorsData: {
      type: Object,
      required: true,
    },
  },

  methods: {
    /**
     * Whether the entry is a structured schematron finding rather than a plain
     * string (XSD errors and legacy responses stay strings).
     *
     * @param {String|Object} message - List entry
     *
     * @return {Boolean}
     */
    isFinding(message) {
      return typeof message === 'object' && message !== null;
    },
  },
};
</script>

<style lang="scss" module>
.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  // Inherited from ValidateResult's scrollable area; centers the message in it.
  // Standalone (no variable in scope) the block just stays compact.
  height: var(--validation-area-height, auto);
}
</style>
